import { PaymentFrequency } from '../config/payment-frequency.enum';
import { ACHDiscountData } from './ach-discount-data.interface';

export interface PlanDetailsToken {
  status: string;
  results: PlanDetails[];
}
export interface PlanDetails {
  status: string;
  contractNumber: string;
  lineItemId: string;
  achDiscountData: ACHDiscountData;
  effectiveDate: string;
  expirationDate: string;
  paymentFrequency: PaymentFrequency;
  planNumber: string;
  price: number;
  tax: number;
  warrantyProductName: string;
}
